import ExerciseForm from '../components/exercises/Form';
import List from '../components/exercises/List';
import CorporateList from '../components/exercises/CorporateList';
import MobileExerciseForm from '../components/exercises/mobileApp/mobileExercise';
import { connect } from "react-redux";
import { fetchFormValues, addExercise, editExercise, fetchMyExercises, fetchMoreExercise, resetExercisesListing, fetchCorporateExercises } from "../store/actions/exercises";
import withAuth from '../hocs/withAuth';
import { saveFile } from '../store/actions/files';
import { showLoader, hideLoader } from '../store/actions/loader';

function mapStateToProps(state, ownProps) {
  var editId = null;
  let userType = ownProps.user && ownProps.user.type;
  if (userType.includes('brand')) userType = 'trainer';
  if (ownProps.match) editId = ownProps.match.params.id;
  if (ownProps.editId) editId = ownProps.editId;
  if (ownProps.workoutId) editId = ownProps.workoutId;
  return {
    errors: state.errors,
    user: state.currentUser.user,
    videos: state.files.exercise,
    cats: state.exerciseCats,
    equipment: state.equipment,
    exercises: state.exercises.trainer,
    isLoadMoreListing: state.exercises.isLoadMore,
    corporateExercises: state.exercises.corporate,
    editId: editId,
    brand: state.brand.detail,
    path: ownProps.match ? ownProps.match.path : null
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchList: (query) => {
      const { type } = query.type;
      delete query.type;
      // if (type && type.includes('corporate')) {
      //   return dispatch(fetchCorporateExercises(query));
      // } else {
        return dispatch(fetchMyExercises(query));
      //}
    },
    fetchFormFilterData: () => {
      return dispatch(fetchFormValues(ownProps.user._id));
    },
    fetch: (userId, editId) => {
      //dispatch(fetchMyExercises(userId));
      return dispatch(fetchFormValues(userId));
    },
    addExercise: (formData, user) => {

      let userType = ownProps.user.type;
      if (userType && userType.includes('trainer')) {
        userType = 'trainer';
      }
      if (userType && userType.includes('brand')) {
        userType = 'brand';
      }
      if (userType && userType.includes('corporate')) {
        userType = 'brand';
      }
      return dispatch(addExercise({
        ...formData,
        creatorId: ownProps.user._id,
        creatorType: userType
      }, user));
    },
    edit: (editId, exercise, user) => {
      return dispatch(editExercise(editId, exercise, user));
    },

    fetchMoreExercises: (query) => {
			return dispatch(fetchMoreExercise(query));
		},
		
		resetExercises: () => {
			return dispatch(resetExercisesListing());
		},

    addFile: (fileMeta) => {
      return dispatch(saveFile(fileMeta));
    },
    showLoader: () => {
      return dispatch(showLoader());
    },
    hideLoader: () => {
      return dispatch(hideLoader());
    },
  }
}
export const EditExercise = withAuth(connect(mapStateToProps, mapDispatchToProps)(ExerciseForm))
export const CreateExercise = withAuth(connect(mapStateToProps, mapDispatchToProps)(ExerciseForm))
export const CorporateExercises = withAuth(connect(mapStateToProps, mapDispatchToProps)(CorporateList))
export const MobileExercise = withAuth(connect(mapStateToProps, mapDispatchToProps)(MobileExerciseForm))
export default withAuth(connect(mapStateToProps, mapDispatchToProps)(List))



// WEBPACK FOOTER //
// ./src/containers/Exercises.js